export default __webpack_public_path__ + "static/media/Thorin's Letter to Bilbo_02.5f4a4b74.jpg";